import { useQuery } from "react-query";

import { makeRequest } from "@/util";
import { GetAccessForManagementResponse } from "../types";

export const ACCOUNT_ENTITLEMENTS_FOR_MANAGEMENT_QUERY_KEY =
  "useAccountEntitlementsForManagement";

export const useAccountEntitlementsForManagement = () => {
  return useQuery(ACCOUNT_ENTITLEMENTS_FOR_MANAGEMENT_QUERY_KEY, async () => {
    const { data: res } = await makeRequest<GetAccessForManagementResponse>(
      "get_account_entitlements_for_management",
    );
    return res;
  });
};
